export default {
  init() {
    const $separatorPlaceholder = $('#separator-placeholder')
    const $productCards = $('.product-list--primary .product-card')

    $productCards
      .each(function(i, el) {
        i = i + 1
        if (i === $productCards.length) {
          return
        }

        const $el = $(el)
        let extraClasses = 'd-md-none'

        if (i > 1) {
          if (i % 2 === 0) {
            extraClasses = 'd-xl-none'
          }

          if (i % 3 === 0) {
            extraClasses = 'd-md-none d-xl-flex'
          }

          if (i % 3 === 0 && i % 2 === 0) {
            extraClasses = ''
          }
        }

        const $sep =
          $separatorPlaceholder
            .clone()
            .attr('id', '')
            .addClass(`products-list__separator ${extraClasses}`)

        $el.after($sep)
      })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerce_Shop.js